import { render, staticRenderFns } from "./Activitys.vue?vue&type=template&id=5e563b55&scoped=true"
import script from "./Activitys.vue?vue&type=script&lang=js"
export * from "./Activitys.vue?vue&type=script&lang=js"
import style0 from "./Activitys.vue?vue&type=style&index=0&id=5e563b55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e563b55",
  null
  
)

export default component.exports